// extracted by mini-css-extract-plugin
export var container = "_7f-0";
export var error = "_7f-9";
export var label = "_7f-5";
export var light = "_7f-6";
export var md = "_7f-3";
export var sm = "_7f-2";
export var thin = "_7f-8";
export var thinBold = "_7f-7";
export var vertical = "_7f-4";
export var xs = "_7f-1";